import { render } from "./SmsServiceParameter.vue?vue&type=template&id=25363865&scoped=true"
import script from "./SmsServiceParameter.vue?vue&type=script&lang=ts"
export * from "./SmsServiceParameter.vue?vue&type=script&lang=ts"

import "./SmsServiceParameter.vue?vue&type=style&index=0&id=25363865&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-25363865"

export default script